const columns = [
  {
    title: "内容栏目",
    links: ["实时热搜", "热度排行", "分类专区", "爆款瓜料", "深度专题"],
  },
  {
    title: "平台说明",
    links: ["关于我们", "数据口径", "吃瓜守则", "免责声明", "媒体合作"],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-accent-100/70">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950">吃瓜合集</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              聚合全网热点讨论的热度资讯平台，让每一场大讨论都清晰可见。独立、客观、不站队，做清醒的吃瓜人。
            </p>
            <div className="mt-4 flex items-center gap-2">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-bilibili-line", label: "哔哩哔哩" },
                { icon: "ri-douban-line", label: "豆瓣" },
                { icon: "ri-zhihu-line", label: "知乎" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#top"
                  onClick={(e) => e.preventDefault()}
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-foreground-200/60 text-foreground-600 transition hover:border-primary-300 hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-3 space-y-2">
                {col.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#top"
                      onClick={(e) => e.preventDefault()}
                      className="text-sm text-foreground-600 transition hover:text-primary-700"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-foreground-200/60 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 吃瓜合集 · 让每一场大讨论都清晰可见</p>
          <div className="flex items-center gap-4">
            <a href="mailto:contact@chiguaheji.example.com" className="flex items-center gap-1 transition hover:text-primary-700">
              <i className="ri-mail-line"></i> contact@chiguaheji.example.com
            </a>
            <span>zh-CN</span>
          </div>
        </div>
      </div>
    </footer>
  );
}